import { Component, OnInit, Inject } from '@angular/core';
import * as moment_ from 'moment';
import { constants } from "src/app/shared/common/contants";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { CommonTs } from "src/app/shared/common/CommonTs";
import { ActivatedRoute } from "@angular/router";
import { ErrorMessages } from "../../shared/common/errormessages"
import { Router } from '@angular/router';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { TrnxCommonService } from "src/app/shared/services/trnx-common.service";
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ScheduleTimeBtn} from '../../shared/common/schedule-time-btn';
import {RunBtn} from '../../shared/common/runBtn';
import {
  IncrementalDataLoadSchedulePopupComponent
} from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import {FiledownloadComponent} from '../../shared/common/filedownload.component';
import {CustomTemplateReportService} from '../../shared/services/custom-template-report.service';
import {EtlService} from '../vault-data-migration-etl/etl.service';

const moment = moment_;

@Component({
    selector: 'app-report-screen',
    templateUrl: './report-screen.component.html',
    styleUrls: ['./report-screen.component.scss'],
    standalone: false
})
export class ReportScreenComponent implements OnInit {
  showMe:boolean = false;
  FormValid: UntypedFormGroup;
  buttonName;
  tableName = "";
  tableID = "";
  getdata: any;
  materialCatData: any
  validation_messages: any
  endDateTemp: any = moment()
  today = new Date()
  startDatetemp: any = moment()
  remarksData: any
  reqparentid: any
  mrqtycode: any
  availableqtycode: any
  soqtycode: any
  value;
  recordsStart = 0;
  backgroundColorScreen = "";
  backgroundColorButton = "";

  gridApiReports;

  rowClassRulesReports;

  defaultColDefReports;

  columnDefsReports;

  rowSelectionReports;

  gridApi;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  pageSize;

  rowClassRules;

  defaultColDef;

  columnDefs;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  agGridShow = false;

  reportName;
  gridOptions


  date = "";
  components: any;
  reportNameShowing;
  reportTemplateId:0

  //constructor
  constructor(
    private router: Router,
    private constants: constants,
    private validation: validationmethod,
    private commonTs: CommonTs,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private service: CommonService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private errorMsg: ErrorMessages,
    private localStorageSettings: LocalStorageSettingsService,
    private trnxService: TrnxCommonService,
    private customTemplateReportService:CustomTemplateReportService,
    private etlService:EtlService,
    private commonServie:CommonService,
  ) {
    this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: ScheduleTimeBtn ,
      runButton:RunBtn,
      downloadbuttonRenderer: FiledownloadComponent,

    }
  }
  scheduleIcon(e) {
    console.log(e.rowData);

    let dialogRef = this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: "80%",
        autoFocus: false,
        data: { edata: e.rowData,scheduleFor:'Report Hub'  },

        disableClose: true,

      });
  }
  ngOnInit() {
    this.formvalidations();
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
   let colId
    this.gridOptions={
      sortModel: [{colId: 0, sort: 'desc'}],
    }

    this.columnDefs = [
      // {
      //   headerName: 'Action',
      //   filter: false,
      //   cellRenderer: 'buttonRenderer',
      //   cellRendererParams: {
      //
      //   },
      //   pinned: 'left',
      //   lockPinned: true,
      //   width: 180,
      // },

      {
        headerName: 'Report History Id',
        headerTooltip: 'Report History Id',
        tooltipValueGetter: (params) =>
          'Report History Id : ' + params.value,
        field: 'reportHistoryId',
        filter: 'agTextColumnFilter',
        width: 100,
      },
      {
        headerName: 'Report Template Name',
        headerTooltip: 'Report Template Name',
        tooltipValueGetter: (params) =>
          'Report Template Name : ' + params.value,
        field: 'reportTemplateName',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Report Generate Date',
        headerTooltip: 'Report Generate Date',
        tooltipValueGetter: (params) =>
          'Report Generate Date : ' + params.value,
        field: 'repgenerateddt',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) =>
          'Status : ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Download Report',
        headerTooltip: 'Download Report',
        field: 'reppath',
        cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {

          docdownload: this.downloadReport.bind(this),


        },
        filter: 'agTextColumnFilter',
        width: 100,
      },
      {
        headerName: 'Run Type',
        headerTooltip: 'Run Type',
        tooltipValueGetter: (params) =>
          'Run Type : ' + params.value,
        field: 'runtype',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Run By',
        headerTooltip: 'Run By',
        tooltipValueGetter: (params) =>
          'runby : ' + params.value,
        field: 'runby',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      // {
      //   headerName: 'Created By',
      //   headerTooltip: 'Created By',
      //   tooltipValueGetter: (params) =>
      //     'Created By : ' + params.value,
      //   field: 'createdBy',
      //   filter: 'agTextColumnFilter',
      //   width: 0,
      // },
      //
      // {
      //   headerName: 'Created Date',
      //   headerTooltip: 'Created Date',
      //   tooltipValueGetter: (params) =>
      //     'Created Date : ' + params.value,
      //   field: 'createdDate',
      //   filter: 'agTextColumnFilter',
      //   width: 0,
      // },
      //
      // {
      //   headerName: 'Last Modified By',
      //   headerTooltip: 'Last Modified By',
      //   tooltipValueGetter: (params) =>
      //     'Last Modified By : ' + params.value,
      //   field: 'lastModifiedBy',
      //   filter: 'agTextColumnFilter',
      //   width: 0,
      // },
      // {
      //   headerName: 'Last Modified Date',
      //   headerTooltip: 'Last Modified Date',
      //   tooltipValueGetter: (params) =>
      //     'Last Modified Date: ' + params.value,
      //   field: 'lastModifiedDate',
      //   filter: 'agTextColumnFilter',
      //   width: 0,
      // },

      ]


    this.columnDefsReports = [
      {
        headerName: 'Report Id',
        field: 'reportcreatormstrid',
        filter: 'agTextColumnFilter',
        width: 100,
        hide: true,
        suppressToolPanel: true
      },
      {
        headerName: 'Report Template Name',
        headerTooltip: 'Report Name',
        tooltipValueGetter: (params) => 'Report Name : ' + params.value,
        field: 'reporttemplatename',
        filter: 'agTextColumnFilter',
        width: 189
      },
      {
        headerName: 'Run',filter: false, cellRenderer: 'runButton',
        cellRendererParams: {

          run: this.run.bind(this)

        },
        lockPinned: true,
        width: 80
      },
      {
        headerName: 'Schedule',filter: false, cellRenderer: 'buttonRenderer',
        field: 'schedules',
        cellRendererParams: {

          schedule: this.scheduleIcon.bind(this)

        },
        lockPinned: true,
        width: 80
      }

    ];

    // // if the record has status==no , row color will change
    // this.rowClassRulesReports = {
    //   "rowBackgroundColor": function (params) {
    //     var numSickDays = params.node.data.status;
    //     return numSickDays === "No" || numSickDays === null;
    //   },
    // };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDefReports = {
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionReports = "single";

    // // if the record has status==no , row color will change
    // this.rowClassRules = {
    //   "rowBackgroundColor": function (params) {
    //     var numSickDays = params.node.data.status;
    //     return numSickDays === "No" || numSickDays === null;
    //   },
    // };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = "single";

    this.paginationPageSize = 10;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.date = "today";

    console.log(this.date);

  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      date: new UntypedFormControl(''),
      startDate: new UntypedFormControl('', [Validators.required]),
      endDate: new UntypedFormControl('', [Validators.required]),
    })
  }

  //excel export function
  onBtExport() {

    this.gridApi.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridApi) {

      this.lastPage = this.gridApi.paginationIsLastPageFound();

      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1

      this.nextPage = this.gridApi.paginationGetCurrentPage() + 1 + 1

      this.nextPagePlusOne = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalPages = this.gridApi.paginationGetTotalPages()

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridApi.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridApi.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    this.gridApi.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridApi.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridApi.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridApi.paginationGoToLastPage();

  }
  //pagination code ends

  // below function is to load the ag grid
  async onGridReadyReports(params) {

    this.gridApiReports = params.api;

    console.log(params);

    let agGridObjectReport:any;

    agGridObjectReport = await this.commonServie.retrieveRecordService('reporttemplateconfig')


     this.gridApiReports.setGridOption('rowData', agGridObjectReport.reverse());

  }

  // below function is to load the ag grid
  onGridReady(params) {

    this.gridApi = params.api;

    this.gridApi.setGridOption('rowData', []);

  }

  async callingReport(reportCreatorMstrId, startDate, endDate) {
    console.log(reportCreatorMstrId);
    let dnsId = this.localStorageSettings.getSettings("dnsName");


    let  colNameAndValues = "dnsid="+dnsId+" and  customreportid = "+this.reportTemplateId +" and date(repgenerateddt) between "+ "'"+startDate+"'" +" and "+"'"+endDate+"'"+" order by reporthistoryid desc"

    this.customTemplateReportService.retrieveGeneratedReportList(this.reportTemplateId,dnsId,startDate,endDate).subscribe(response=>{

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      }
      else {
        this.gridApi.setGridOption('rowData', response);
        this.spinner.stop();


      }
    })




  }
  collapse(){
    console.log()
     this.showMe=!this.showMe;

     // this.gridApi = params.api;

   }
  //  expand(){


  //    this.showMe=true;


  //  }


  ChangeSelect(event) {
    var getyear = moment().format("YYYY");
    var getmonth = moment().format("MM");
    if (event.value == "today") {
      this.endDateTemp = moment()
      this.startDatetemp = moment()
    } else if (event.value == "currentWeek") {
      this.endDateTemp = moment().endOf('week')
      this.startDatetemp = moment().startOf("isoWeek");
    } else if (event.value == "currentMonth") {
      this.endDateTemp = moment().endOf('month')
      this.startDatetemp = moment(getyear + "-" + getmonth, "YYYY-M").startOf("month");
    }
  }

  senddata() {
    if (!this.FormValid.valid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.FormValid);
      this.validation.getvalidationmessage();
      return
    } else {
      var startDate = moment(this.startDatetemp).format('YYYY-MM-DD');
      var endDate = moment(this.endDateTemp).format('YYYY-MM-DD');
      console.log(this.reportTemplateId);
      if(this.reportTemplateId == undefined){

        this.snackBar.open(this.constants.checkingReportId,"OK",{duration:5000});

      }

      else{

        this.callingReport(this.reportTemplateId, startDate, endDate)

      }

    }
  }

  reset() {
    this.FormValid.controls['startDate'].reset();
    this.FormValid.controls['endDate'].reset();
  }

  clearData() {
    this.reset();
    this.endDateTemp = moment(null)
    this.startDatetemp = moment(null)
    this.date = null
    this.gridApi.setGridOption('rowData', [])
    this.FormValid.reset()
  }

  getReportDetails(e){
    console.log(e);
    console.log("inside get reportDelails columnid: "+e.column.colId)
    this.reportTemplateId = e.data.reporttemplateid;
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    var startDate = moment(this.startDatetemp).format('YYYY-MM-DD');
    var endDate = moment(this.endDateTemp).format('YYYY-MM-DD');

    this.customTemplateReportService.retrieveGeneratedReportList(this.reportTemplateId,dnsId,startDate,endDate).subscribe(response=>{

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });


      }
      else {

        this.gridApi.setGridOption('rowData', response);
        this.spinner.stop();


      }
    })




  }

  onRowDoubleClick($event: any) {

  }
  run(e) {
    if (confirm('Are you sure you want to generate a report ?')) {
      let reportid = e.rowData.reporttemplateid
      if (reportid) {
        let dnsId = this.localStorageSettings.getSettings("dnsName");
        this.spinner.start()
        this.customTemplateReportService.runCustomReportGenerationManually(reportid, dnsId).subscribe(response => {
          this.spinner.stop();
          this.snackBar.open(response.statusMessage, "OK", {duration: 5000});
        })
      }else{

        this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      }

    }
  }

  s3FilePath
  downloadReport(e){
    console.log(e.rowData);
    console.log(e.rowData.reppath);
    this.s3FilePath = e.rowData.reppath
    if (this.s3FilePath) {
    let fileName =  this.s3FilePath.split('/').pop()
    let data = {
      s3Path:this.s3FilePath,
    };
    this.spinner.start();
    this.etlService.downloadFileFromS3(data).subscribe(x => {
      this.spinner.stop()
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should

      console.log(x)
      const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
      const responseData = isJsonBlob(x)
      if (responseData){
        this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      }
      else{
        console.log(x)
        var newBlob = new Blob([x]);
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)

        var link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);

      }

    })
  }
  else{

  this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

}

    this.spinner.stop();
  }
}
